import React, { useEffect } from 'react';
import { firebaseApp } from '../api/firebase';
import { FirestoreProvider } from 'react-firestore';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { BrowserRouter, useLocation } from 'react-router-dom';
import 'bulma/css/bulma.css';
import '../styles/bulma-tooltip.css';
import '../styles/bulma-switch.css';
import '../styles/bulma-checkradio.css';
import '../styles/bulma-divider.css';
import '../styles/global';
import '../styles/animation';
// New design system
import '../design-system/tokens/index.css';
import ErrorBoundary from './misc/ErrorBoundary';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import AppRoutes from './Routes';
import Layout from './layout/Layout';

/**
 * Analytics component - tracks page views with Google Analytics
 * Uses React Router v6 useLocation hook
 */
function Analytics() {
  const location = useLocation();

  useEffect(() => {
    const page = location.pathname + location.search;
    ReactGA.set({ page });
    ReactGA.pageview(page);
  }, [location]);

  return null;
}

/**
 * Main App component
 * Converted to functional component for React 18
 */
function App() {
  return (
    <FirestoreProvider firebase={firebaseApp}>
      <BrowserRouter>
        <ErrorBoundary>
          <Helmet>
            <script async src='https://r.wdfl.co/rw.js' data-rewardful='ed8d2c'></script>
          </Helmet>
          <Layout>
            <Analytics />
            <AppRoutes />
          </Layout>
        </ErrorBoundary>
      </BrowserRouter>
    </FirestoreProvider>
  );
}

export default App;
